export const minWordsToPracticeSpecificBook = 6;

// If the server version is detected to be ahead of the client version, the client will be forced to
// do a full page refresh to ensure compatibility.
export const clientServerCompatibilityVersion = 2;

export const audioUploadLimitPremium = 10 * 3600; // seconds
export const audioUploadLimitPremiumPlus = 200 * 3600; // seconds

/**
 * Epubs are posted as multipart/form-data, so the raw file size is what goes
 * over the wire. Kept comfortably under nginx's global `client_max_body_size`
 * of 25M.
 */
export const epubUploadLimitMB = 20;

/** For purposes of calculating daily streak goal */
export const wordEquivalentOfPractice = 50;

/** Maximum length of a chat user message in number of characters */
export const maxChatMessageLength = 800;
